<template>
  <div class="CTI_setting" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="pstnNumber" placeholder="请输入热线号码" title="热线号码"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="queueNum" placeholder="请选择号码" clearable>
          <OptionGroup label="普通技能组">
            <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
          </OptionGroup>
          <OptionGroup label="AI技能组">
            <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
          </OptionGroup>
        </Select>
      </div>
      <div class="fixed_operation_btn"><Button type="primary" @click="initSearch">查询</Button></div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
        <el-table-column  fixed="right" label="操作" width="200" v-if="contentList.length>0"  align="center">
          <template slot-scope="scope">
            <el-button v-if="roleList['3_5-1-1']" @click="editPstnNumber(scope.row.id)" type="text" size="small">编辑</el-button>
            <el-button v-if="roleList['3_5-1-2']" @click="timeDefinition(scope.row.pstnNumber)" type="text" size="small">时间定义</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <pstnNumberPop :showPstnNumber="showPstnNumber"  @closePstnNumber="closePstnNumber" :pstnNumberId="pstnNumberId" :queueList="queueList" :queueList2="queueList2"></pstnNumberPop>
    <pstnNumberTimePop :showPstnTime="showPstnTime"  @closePstnTime="closePstnTime" :pstnNumberId="pstnNumberId"></pstnNumberTimePop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import pstnNumberPop from '@/components/systemSetup/CTIConfigure/PstnNumberPop.vue'
  import pstnNumberTimePop from '@/components/systemSetup/CTIConfigure/PstnNumberTimePop.vue'
  export default {
    name: "PstnNumberTable",
    mixins:[publicFunClass],
    components:{
      pstnNumberPop,
      pstnNumberTimePop
    },
    props:{
      pageCode:String
    },
    data(){
      return{
        showPageCount:0,
        spinShow:true,
        fieldList: [
          {key:'pstnNumber','title':'热线号码'},{key:'pstnNumberName','title':'热线名称'},{key:'areaCode','title':'热线号码区号'},{key:'isCall','title':'启用分时段'},
          {key:'numberType','title':'业务类型'},{key:'numberList','title':'号码'},{key:'voiceNavigation','title':'语音导航'},{key:'desc','title':'备注'}
        ],
        contentList: [],
        checkIds:[],
        tableHeight:600,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        screenHeight:{height:''},
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        speedChangePage: 1,
        pageSize:20,
        pstnNumber:'',
        queueNum:'',
        queueList:[],
        queueList2:[],
        showPstnNumber:false,
        showPstnTime:false,
        pstnNumberId:''
      }
    },
    methods:{
      closePstnNumber:function(flag){
        this.showPstnNumber=false;
        if(flag){
          this.initSearch();
        }
      },
      //编辑热线号码
      editPstnNumber:function(id){
        this.showPstnNumber=true;
        this.pstnNumberId=id+'';
      },
      closePstnTime:function(){
        this.showPstnTime=false;
      },
      //切换刷新时间
      timeDefinition:function(pstnNumber){
        this.showPstnTime=true;
        this.pstnNumberId=pstnNumber;
      },
      initSearch:function () {
        this.spinShow=true;
        let that=this;
        let param={
          pstnNumber:this.pstnNumber,
          queueName:this.queueNum,
          journalType:"系统管理=>CTI配置=>热线号码查询",
          menuId:"null",
          pageNum:this.currentPage,
          pageSize:this.pageSize
        };
        this.$http.post("pstnNumber/toIndex.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
        });
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-182;
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='3_5-1' && this.showPageCount==0){
          this.showPageCount++;
          this.getQueue('3');
          this.initSearch();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/PstnNumberTable.vue